// Brand in the map UI: the wordmark is the title of the main menu list (left in the drawer header).
import {BRAND_WORDMARK_EU} from './brand.mjs';
import {t} from './i18n.mjs';

// Main menu list title: wordmark for the eye, the catalog word for the dialog name (aria-labelledby="menu-title").
// Keep the title slot height when removing the square icon; the header and its air below the handle stay unchanged.
export const menuBrandTitle = () => `<span class="sr-only" data-i18n="menuTitle">${t('menuTitle')}</span><span class="brand-title">${BRAND_WORDMARK_EU}</span>`;
export function setMenuTitle(title, key) {
  const brand = key === 'menuTitle';
  title.classList?.toggle('menu-brand', brand);
  if (brand) { delete title.dataset.i18n; title.innerHTML = menuBrandTitle(); }
  else { title.dataset.i18n = key; title.textContent = t(key); }
}
